import { lazy, Suspense, memo } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import SectionDivider from "@/components/SectionDivider";

// Lazy load below-the-fold sections to reduce initial bundle
const WhoIsThisForSection = lazy(() => import("@/components/WhoIsThisForSection"));
const CoreProblemSection = lazy(() => import("@/components/CoreProblemSection"));
const FeatureSection = lazy(() => import("@/components/FeatureSection"));
const FounderStorySection = lazy(() => import("@/components/FounderStorySection"));
const StickyCTA = lazy(() => import("@/components/StickyCTA"));


const ComparisonSection = lazy(() => import("@/components/ComparisonSection"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const CalendlySection = lazy(() => import("@/components/CalendlySection"));
const Footer = lazy(() => import("@/components/Footer"));

const BackgroundOrbs = memo(() => (
  <>
    <div className="absolute top-20 left-20 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-float will-change-transform" />
    <div className="absolute bottom-40 right-20 w-48 h-48 bg-accent/10 rounded-full blur-3xl animate-float will-change-transform" style={{ animationDelay: '2s' }} />
  </>
));

const Index = memo(() => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background/80 to-secondary/20" />
      <BackgroundOrbs />
      
      <div className="relative z-10">
        <Navigation />
        <HeroSection />
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-64 bg-background/50" />}>
          <WhoIsThisForSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-64 bg-background/50" />}>
          <CoreProblemSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-96 bg-background/50" />}>
          <FeatureSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-64 bg-background/50" />}>
          <FounderStorySection />
        </Suspense>
        
        <SectionDivider />
        


        
        <Suspense fallback={<div className="h-96 bg-background/50 animate-pulse" />}>
          <ComparisonSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-20 bg-background/50 animate-pulse" />}>
          <StatsSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-64 bg-background/50 animate-pulse" />}>
          <FAQSection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-32 bg-background/50 animate-pulse" />}>
          <CTASection />
        </Suspense>
        
        <SectionDivider />
        
        <Suspense fallback={<div className="h-96 bg-background/50 animate-pulse" />}>
          <CalendlySection />
        </Suspense>
        
        <Suspense fallback={<div className="h-32 bg-background/50 animate-pulse" />}>
          <Footer />
        </Suspense>
      </div>

      <Suspense fallback={null}>
        <StickyCTA />
      </Suspense>
    </div>
  );
});

BackgroundOrbs.displayName = 'BackgroundOrbs';
Index.displayName = 'Index';

export default Index;